import { Body, Box } from '../layout'
import React from 'react'

export const Field = ({ name, label, type = 'text', fullWidth, required, faintBackground }) => (
  <Box column gap={4} fullWidth={fullWidth}>
    <Body alt small weight={600}>{label}</Body>
    {type === 'textArea'
      ? <textarea name={name} required={required} style={{ background: faintBackground && 'rgba(255, 255, 255, 0.10)' }} />
      : <input name={name} required={required} type={type} style={{ background: faintBackground && 'rgba(255, 255, 255, 0.10)' }} />
    }
  </Box>
)